import clsx from 'clsx';
import { InputCheckbox } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

const GoogleClassroomStudentItem = ({ selected, classGuid, guid, avatar, name, lastname, email, onChangeSelected }) => {
  return (
    <div className={clsx('google-classroom-student-item', { 'google-classroom-student-item--selected': selected })}>
      <div className="google-classroom-student-item__wrapper">
        <div className="google-classroom-student-item__left">
          <div className="google-classroom-student-item__check">
            {/* Hidden label gives the checkbox an accessible name (the visible name is a sibling). */}
            <InputCheckbox
              checked={selected}
              label={<span className="sr-only">{`${name} ${lastname || ''}`}</span>}
              onChange={() => onChangeSelected(classGuid, guid, !selected)}
            />
          </div>
          <div className="google-classroom-student-item__avatar">
            <img src={'https:' + avatar} alt="" referrerPolicy="no-referrer" />
          </div>
          <div className="google-classroom-student-item__name">
            {name} {lastname}
          </div>
        </div>
        <div className="google-classroom-student-item__right">
          <div className="google-classroom-student-item__email">{email}</div>
        </div>
      </div>
    </div>
  );
};

GoogleClassroomStudentItem.propTypes = {
  avatar: PropTypes.string,
  classGuid: PropTypes.string,
  email: PropTypes.string,
  guid: PropTypes.string,
  lastname: PropTypes.string,
  name: PropTypes.string,
  onChangeSelected: PropTypes.func,
  selected: PropTypes.bool,
};

GoogleClassroomStudentItem.defaultProps = {
  selected: false,
  onChangeSelected: () => {},
};

export default GoogleClassroomStudentItem;
